import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import { getType } from 'typesafe-actions';
import { actions } from '..';
import { Command } from '../../model';
import { isDefined } from '../../type-utils';
import { Actions, StoreState } from '../types';
import { getCommandIdFromCommand } from '../../Components/CallPopup';

interface CommandById {
  [id: string]: Command | undefined
}


function commandsById(state: CommandById = {}, action: Actions): CommandById {
  switch (action.type) {

    case getType(actions.removeCommand): {
      const newState = { ...state }
      delete newState[action.payload]
      return newState
    }

    case getType(actions.updateMediaCommand): {
      const { command } = action.payload
      const id = getCommandIdFromCommand(command)

      if (command.CommandType === "SHUTDOWN") {
        const newState = { ...state }
        delete newState[id]
        return newState
      }

      //else replace/update
      return {
        ...state,
        [id]: command,
      }
    }

    case getType(actions.acceptCommand): {
      const { id } = action.payload
      const command = state[id]
      if (command) {
        return {
          ...state,
          [id]: {
            ...command,
            Hide: true,
          },
        }
      }
      return state
    }

    case getType(actions.shutdown): {
      return {}
    }

    default:
      return state
  }
}

export default combineReducers({
  commandsById,
})

function getRoot(state: StoreState) { return state.command }
function getCommandsById(state: StoreState) { return getRoot(state).commandsById }

export function getCommandById(state: StoreState, id: string) {
  return getCommandsById(state)[id]
}

export function selectMediaCommand(state: StoreState, callId: string): Command | undefined {
  return selectCommands(state).filter(c => c.ExtendedInfo.QueueItems && c.ExtendedInfo.QueueItems.Key === callId)[0]
}

export const selectCommands = createSelector(
  getCommandsById,
  commands => {
    return Object.values(commands).filter(isDefined)
  },
)
